import { Ticket } from '@models/ticket.model';

export class UpdateTickets {
  static readonly type = '[Reservation] Update Tickets';
  constructor(public tickets: Ticket[][]) {}
}
